import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Login from "../views/auth/Login.vue";
import Register from "../views/auth/Register.vue";
import UserProfile from "../views/examplesApi/UserProfile/EditUserProfile.vue";
import UserManagement from "../views/examplesApi/UserManagement/ListUserPage.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";
import auth from "../middleware/auth";
import guest from "../middleware/guest";PricingCustomizeTradingNew

// new
import { ExternalUserList, ExternalUserDetail, ExternalUserNew, ExternalUserKYCDetail, ExternalUserReferred, ExternalUserRecap} from "../views/users-management/external";
import { InternalUserList, InternalUserNew, InternalUserEdit } from "../views/users-management/internal";
import { RoleList, RoleNew, RoleEdit } from "../views/users-management/roles";
import { PricingSmartTradeList, PricingSmartTradeNew, PricingSmartTradeEdit } from "../views/pricings-management/smart-trade";
import { PricingEducationalList, PricingEducationalNew, PricingEducationalEdit } from "../views/pricings-management/educational-class";
import { PricingSignalList, PricingSignalNew, PricingSignalEdit } from "../views/pricings-management/signals";
import { PricingIndicatorList, PricingIndicatorNew, PricingIndicatorEdit } from "../views/pricings-management/indicators";
import { PricingCustomizeTradingList, PricingCustomizeTradingNew, PricingCustomizeTradingEdit } from "../views/pricings-management/customize-trading";
import { InvoiceList, InvoiceEdit, InvoiceFile } from "../views/transactions/invoices";
import { OrderList } from "../views/transactions/orders";
import { ProductOneTimeNew, ProductOneTimeList, ProductOneTimeEdit } from "../views/pricings-management/one-time";
import { ProductSubscriptionNew, ProductSubscriptionList, ProductSubscriptionEdit } from "../views/pricings-management/subscriptions";
import { BroadcastSignalList, BroadcastSignalNew, BroadcastSignalEdit } from "../views/broadcast-signal";
import { BannerList } from "../views/content-management/banners";
import { AchievementList, AchievementEdit } from "../views/achievements";
import { SubscriptionList, SubscriptionEdit } from "../views/subscriptions";
import { RecapList } from "../views/recaps";
import  Table from "../views/Tables";
// import { MarginRateList } from "../views/content-management/margin-rates";
import { RateList } from "../views/content-management/rates";
import { ServiceFeeList } from "../views/content-management/services-fee";
import { ProfitTargetList } from "../views/content-management/profit-targets";
import { ServiceProviderAgreement } from "../views/legal-documents";
import StatementLetter from "../views/legal-documents/StatementLetter.vue";


const routes = [
  {
    path: "/tables",
    name: "Tables",
    component: Table,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/roles",
    name: "Role",
    component: RoleList,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/roles/new",
    name: "Add Role",
    component: RoleNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/roles/:id/edit",
    name: "Edit Role",
    component: RoleEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/internal-users",
    name: "Internal User",
    component: InternalUserList,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/internal-users/new",
    name: "Add Internal User",
    component: InternalUserNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/internal-users/:id/edit",
    name: "Edit Internal User",
    component: InternalUserEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/external-users",
    name: "External User",
    component: ExternalUserList,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/external-users/new",
    name: "Add External User",
    component: ExternalUserNew,
    meta: {
      middleware: auth,
    },
  },
   {
    path: "/external-users/:id",
    name: "Detail External User",
    component: ExternalUserDetail,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/external-users/:id/referred",
    name: "Referred External User",
    component: ExternalUserReferred,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/external-users/kyc/:id",
    name: "Detail KYC External User",
    component: ExternalUserKYCDetail,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/external-users/:id/recap",
    name: "Recap External User",
    component: ExternalUserRecap,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/examples/user-profile",
    name: "User Profile",
    component: UserProfile,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/examples/user-management/list-users",
    name: "User Managemant",
    component: UserManagement,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/products/one-time",
    name: "One Time Products",
    component: ProductOneTimeList,
  },
  {
    path: "/products/one-time/new",
    name: "Add One Time Product",
    component: ProductOneTimeNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/products/one-time/:id/edit",
    name: "Edit One Time Product",
    component: ProductOneTimeEdit,
    meta: {
      middleware: auth,
    },
  },

  {
    path: "/products/subs",
    name: "Subscription Products",
    component: ProductSubscriptionList,
  },
  {
    path: "/products/subs/new",
    name: "Add Subscription Product",
    component: ProductSubscriptionNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/products/subs/:id/edit",
    name: "Edit Subscription Product",
    component: ProductSubscriptionEdit,
    meta: {
      middleware: auth,
    },
  },

  {
    path: "/pricings/smart-trade",
    name: "Pricing SSMARTBOT",
    component: PricingSmartTradeList,
  },
  {
    path: "/pricings/smart-trade/new",
    name: "Add Pricing SSMARTBOT",
    component: PricingSmartTradeNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/smart-trade/:id/edit",
    name: "Edit Pricing SSMARTBOT",
    component: PricingSmartTradeEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/signals",
    name: "Pricing Signal",
    component: PricingSignalList,
  },
  {
    path: "/pricings/signals/new",
    name: "Add Pricing Signal",
    component: PricingSignalNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/signals/:id/edit",
    name: "Edit Pricing Signal",
    component: PricingSignalEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/indicators",
    name: "Pricing Indicator",
    component: PricingIndicatorList,
  },
  {
    path: "/pricings/indicators/new",
    name: "Add Pricing Indicator",
    component: PricingIndicatorNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/indicators/:id/edit",
    name: "Edit Pricing Indicator",
    component: PricingIndicatorEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/customize-trading",
    name: "Pricing CustomizeTrading",
    component: PricingCustomizeTradingList,
  },
  {
    path: "/pricings/customize-trading/new",
    name: "Add Pricing CustomizeTrading",
    component: PricingCustomizeTradingNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/customize-trading/:id/edit",
    name: "Edit Pricing CustomizeTrading",
    component: PricingCustomizeTradingEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/educational-class",
    name: "Pricing EducationalClass",
    component: PricingEducationalList,
  },
  {
    path: "/pricings/educational-class/new",
    name: "Add Pricing EducationalClass",
    component: PricingEducationalNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/pricings/educational-class/:id/edit",
    name: "Edit Pricing EducationalClass",
    component: PricingEducationalEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: InvoiceList,
  },
  {
    path: "/invoices/:id/edit",
    name: "Edit Invoices",
    component: InvoiceEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/invoices/:id/file",
    name: "File Invoices",
    component: InvoiceFile,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/orders",
    name: "Orders",
    component: OrderList,
  },
  {
    path: "/subscriptions",
    name: "Subscription",
    component: SubscriptionList,
  },
  {
    path: "/subscriptions/:id/edit",
    name: "Edit Subscription",
    component: SubscriptionEdit,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/recaps",
    name: "Recap Expired",
    component: RecapList,
  },
  // {
  //   path: "/recaps/:id/edit",
  //   name: "Edit Recap",
  //   component: RecapEdit,
  //   meta: {
  //     middleware: auth,
  //   },
  // },
  {
    path: "/service-provider-agreement/:id",
    name: "Service Provider Agreement",
    component: ServiceProviderAgreement,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/statement-letter/:id",
    name: "Statement Letter",
    component: StatementLetter,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/password/forgot",
    name: "Forgot Password",
    component: ForgotPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/password/reset",
    name: "Reset Password",
    component: ResetPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/broadcast-signal",
    name: "Broadcast Signal",
    component: BroadcastSignalList,
  },
  {
    path: "/achievements",
    name: "Target Profit",
    component: AchievementList,
  },
  {
    path: "/achievements/:id/edit",
    name: "Edit Target Profit",
    component: AchievementEdit,
  },
  // {
  //   path: "/content-management/margin-rates",
  //   name: "Margin Rate",
  //   component: MarginRateList,
  // },
  {
    path: "/content-management/services-fee",
    name: "Services Fee",
    component: ServiceFeeList,
  },
  {
    path: "/content-management/rate",
    name: "Rate",
    component: RateList,
  },
  {
    path: "/content-management/profit-targets",
    name: "Profit Targets",
    component: ProfitTargetList,
  },
  {
    path: "/broadcast-signal/new",
    name: "Add Broadcast Signal",
    component: BroadcastSignalNew,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/broadcast-signal/:id/edit",
    name: "Edit Broadcast Signal",
    component: BroadcastSignalEdit,
    meta: {
      middleware: auth,
    },
  },

  {
    path: "/content-management/banners",
    name: "Banner List",
    component: BannerList,
  },  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Creates a nextMiddleware() function which not only
// runs the default next() callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default next() callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router next() callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // nextMiddleware() callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
